import { DeleteDocumentActionParameters, DeleteDocumentActions, deleteDocumentActionTypes, DeleteDocumentResponse } from ".."
import { ErrorFetchingAction, FeedItem, FetchErrorInfo, SuccessFetchingAction } from "../../.."
import { CLEAR_FEED_ITEMS, ExpandFeedItemCommentAction, EXPAND_FEED_ITEM_COMMENTS, FeedItemsActions, fetchFeedItemsActionTypes, loadMoreFeedItemsActionTypes, LoadMoreFeedItemsAdditionalData, LoadMoreFeedItemsAction } from "./actions"

export type FeedItemsState = {
    data: FeedItem[]
    error?: FetchErrorInfo
    page: number
    hasMore: boolean
    isFetching: boolean
    isLoadingMore: boolean
}

export const initialFeedItemsState: FeedItemsState = {
    data: [],
    isFetching: false,
    page: 0,
    hasMore: true,
    isLoadingMore: false,
}

const uniqueFeedItems = (items: FeedItem[]): FeedItem[] => {
    const presentedIds: string[] = []
    const filtered = items.reduce((accum: FeedItem[], item): FeedItem[] => {
        if(presentedIds.includes(item.docId)) return accum
        presentedIds.push(item.docId)
        return [...accum, item]
    }, [])
    return filtered
}

export const feedItemsReducer = (state: FeedItemsState = initialFeedItemsState, action: FeedItemsActions | DeleteDocumentActions | LoadMoreFeedItemsAction): FeedItemsState => {
    switch (action.type) {
        case fetchFeedItemsActionTypes.start: {
            return {
                ...state,
                isFetching: true,
                data: [...state.data]
            }
        }
        case loadMoreFeedItemsActionTypes.start: {
            return {
                ...state,
                isLoadingMore: true,
            }
        }
        case fetchFeedItemsActionTypes.success: {
            const successAction = action as SuccessFetchingAction<FeedItem[]>
            const res = [...successAction.result]

            return {
                ...state,
                hasMore: !!successAction.result.length,
                page: 0,
                isFetching: false,
                data: res
            }
        }
        case loadMoreFeedItemsActionTypes.success: {
            const successAction = action as SuccessFetchingAction<FeedItem[], LoadMoreFeedItemsAdditionalData>
            const {additionalData} = successAction
            

            const nextItems = [...successAction.result]
            const oldItems = [...state.data]
            const uniqueItems = uniqueFeedItems([...oldItems, ...nextItems])
            return {
                ...state,
                page: additionalData ? !!nextItems.length ? additionalData.page : state.page : 0,
                isLoadingMore: false,
                hasMore: !!nextItems.length,
                data: uniqueItems
            }
        }
        case fetchFeedItemsActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                ...state,
                isFetching: false,
                data: [...state.data],
                error: errorAction.error
            }
        }
        case fetchFeedItemsActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                ...state,
                isLoadingMore: false,
                data: [...state.data],
                error: errorAction.error
            }
        }
        case EXPAND_FEED_ITEM_COMMENTS: {
            const expandAction = action as ExpandFeedItemCommentAction
            return {
                ...state,
                data: state.data.map(x => {
                    if (x.docId !== expandAction.docId) return x
                    return {...x, commentsExpanded: true}
                })
            }
        }
        case deleteDocumentActionTypes.success: {
            const deleteAction = action as SuccessFetchingAction<DeleteDocumentResponse, DeleteDocumentActionParameters>
            if (!deleteAction.additionalData) {
                return state
            }
            const docId = deleteAction.additionalData.docId
            return {
                ...state,
                data: state.data.filter(x => x.docId !== docId)
            }
        }
        case CLEAR_FEED_ITEMS: {
            return {
                ...state,
                data: [],
                page: 0,
                hasMore: true,
                isLoadingMore: false,
                isFetching: false
            }
        }
        default:
            return state
    }
}